import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let url = request.url;

    if (request.url.startsWith('/api')) {
      url = environment.apiUrl + url.slice(4);
    }
    else if (request.url.startsWith('file')) {
      url = environment.downloadPath + url.slice(4);
    }


    const token = localStorage.getItem('jwt_token');

    return next.handle(
      request.clone({
        url: url,
        headers: token ? request.headers.set("Authorization", "Bearer " + token) : request.headers
      })
    );
  }
}
